<template>
    <BaseFilter btn-filter-id="btn-nbox-filter" v-slot="{ hideContent }">
        <Managers
            showLabel
            enableSelectAll
            :closeOnSelect="false"
            :value.sync="filters.managers"
        />
        <Committee
            multiple
            lazyLoading
            enableSelectAll
            :value.sync="filters.committees"
        />
        <TextArea
            :value.sync="filters.names"
            :label="$t('people.searchByName')"
            :description="$t('people.instructions.bulkSearch')"
        />
        <div class="d-flex justify-content-between">
            <b-form-checkbox v-model="filters.applyToAll" switch>
                {{ $t('nBox.applyToAllNBoxes') }}
            </b-form-checkbox>
            <b-button
                size="sm"
                variant="primary"
                @click="
                    () => {
                        onClickSearch()
                        hideContent()
                    }
                "
            >
                {{ $t('form.button.filter') }}</b-button
            >
        </div>
    </BaseFilter>
</template>
<script>
import BaseFilter from '@/views/components/filters'
import {
    Managers,
    Committee,
    CTextArea as TextArea,
} from '@/views/components/fields'
import { EventBuzz } from '@/main'

export default {
    components: {
        Managers,
        Committee,
        TextArea,
        BaseFilter,
    },
    data() {
        return {
            id: Math.random(),
            filters: {
                names: '',
                managers: [],
                committees: [],
                applyToAll: false,
            },
        }
    },
    mounted() {
        EventBuzz.$on('search-all', (filterId, newFilters) => {
            if (this.id != filterId) {
                this.filters = newFilters
                this.onClickSearch()
            }
        })
    },
    methods: {
        onClickSearch() {
            if (this.filters.applyToAll) {
                EventBuzz.$emit('search-all', this.id, {
                    ...this.filters,
                    applyToAll: false,
                })
            }

            this.$emit('search', this.parseFilters())
        },
        parseFilters() {
            let names = this.filters.names.trim()
            names = names.length ? names.split('\n').map((n) => n.trim()) : []
            return {
                names,
                managers: this.filters.managers.map((m) => m.value),
                committees: this.filters.committees.map((c) => c.value),
            }
        },
    },
}
</script>
